import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function YouTubeIcon({
	width,
	height,
	active = false,
	customIconColor,
	'aria-label': ariaLabel = 'YouTube',
	style,
	...rest
}: IconRenderProps): ReactElement {
	const bg = customIconColor?.bgColor ?? '#FFFFFF';
	const g = customIconColor?.glyphColor ?? (active ? '#1E1E1E' : 'rgba(30, 30, 30, 0.48)');

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width ?? '100%'}
			height={height ?? '100%'}
			viewBox="0 0 40 40"
			fill="none"
			role="img"
			aria-label={ariaLabel}
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<title>YouTube</title>
			<path
				d="M33.6188 40H6.38086C2.86255 40 0 37.1375 0 33.6188V6.38086C0 2.86255 2.86255 0 6.38086 0H33.6188C37.1375 0 39.9996 2.86255 39.9996 6.38086V33.6188C39.9996 37.1375 37.1371 40 33.6188 40Z"
				fill={bg}
			/>
			<path
				d="M20 12C9.64957 12.1918 9 11.5672 9 20C9 28.4328 9.62112 27.7754 20 28C30.5211 27.6852 31 28.3984 31 20C31 11.6016 30.0059 12.1328 20 12ZM19.292 22.5475L17.8205 23.4443V16.5443L23.4786 19.9984L19.292 22.5475Z"
				fill={g}
			/>
		</svg>
	);
}
